import { AxiosRequestConfig } from 'axios';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { Employee } from '@/types';
import { useGetEmployeesQuery } from '@/services';
import { useAsyncSearch } from '@/hooks';

function SearchEmployees<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  value,
  ...props
}: { config?: AxiosRequestConfig<Employee> } & Omit<
  AutocompleteProps<Employee, Multiple, DisableClearable, FreeSolo>,
  'options'
>) {
  const asyncGetEmployeesQueryProps = useAsyncSearch<Employee, Multiple, DisableClearable, FreeSolo>(
    useGetEmployeesQuery,
    'id',
    value,
    config,
  );

  return <Autocomplete {...props} {...asyncGetEmployeesQueryProps} />;
}

export default SearchEmployees;
